"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useMediaQuery } from "usehooks-ts";
import { Backdrop } from "@filadd/phi-plus-core";
import { token } from "@filadd/phi-plus-styled-system/tokens";
import { MobileSideNavDrawer } from "./MobileSideNavDrawer";
import { sideNavLayoutRecipe } from "./recipes";
import { SideNav } from "./SideNav";
import { TopBar } from "./TopBar";
const SIDENAV_EXPAND_COOKIE_NAME = "sideNavExpanded";
export const SideNavLayout = (_a) => {
    var { ssrCookies, topBar, children, fixed = false, goBack } = _a, props = __rest(_a, ["ssrCookies", "topBar", "children", "fixed", "goBack"]);
    const isMobile = useMediaQuery(`(max-width: ${token("sizes.breakpoint-md")})`, { defaultValue: false, initializeWithValue: false });
    const [expanded, setExpanded] = useState((ssrCookies === null || ssrCookies === void 0 ? void 0 : ssrCookies[SIDENAV_EXPAND_COOKIE_NAME]) === String(true));
    useEffect(() => {
        if (String(expanded) !== Cookies.get(SIDENAV_EXPAND_COOKIE_NAME)) {
            Cookies.set(SIDENAV_EXPAND_COOKIE_NAME, String(expanded));
        }
    }, [expanded, ssrCookies]);
    const styles = sideNavLayoutRecipe({ expanded, fixed });
    const onToggle = () => {
        setExpanded(!expanded);
    };
    useEffect(() => {
        if (fixed) {
            setExpanded(false);
        }
    }, [fixed, setExpanded]);
    return (_jsxs("div", { className: styles.container, children: [isMobile ? (_jsx(MobileSideNavDrawer, { topBar: topBar, goBack: goBack, children: _jsx(SideNav, Object.assign({}, props, { open: true })) })) : (_jsxs(_Fragment, { children: [fixed && expanded && _jsx(Backdrop, { onUnmount: onToggle }), _jsx("div", { className: styles.desktopSidenavWrapper, children: _jsx(SideNav, Object.assign({}, props, { open: expanded, onToggle: onToggle })) })] })), _jsx("div", { className: styles.contentContainer, children: _jsxs("div", { className: styles.contentWrapper, children: [!isMobile && (goBack != null || topBar != null) && (_jsx(TopBar, { goBack: goBack, children: topBar })), children] }) })] }));
};
//# sourceMappingURL=SideNavLayout.js.map